export const appSynonymGlobal = {
  wordpress: 'plugin',
  joomla: 'extension',
  drupal: 'module',
  wix: 'app',
  weebly: 'app',
  shopify: 'app',
  webflow: 'app',
  shift4shop: 'app',
  prestashop: 'module',
  modx: 'extra',
  websitex5: 'object',
  opencart: 'extension',
  nopcommerce: 'plugin',
}